import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTaxValueOfPrice',
})
export class GetTaxValueOfPricePipe implements PipeTransform {
  transform(value: any, rate: any): any {
    return value - value / (rate / 100 + 1);
  }
}
